import { MasterFieldsFragment } from 'generated/graphql';

export type Master = MasterFieldsFragment;

export const getEpTitle = (master?: Master | null) =>
  master?.title ? `${master.title} EP` : '';
